import { apiRequest } from "./api";

function urlBase64ToBytes(value: string): Uint8Array<ArrayBuffer> {
  const padding = "=".repeat((4 - value.length % 4) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const bytes = new Uint8Array(new ArrayBuffer(raw.length));
  for (let index = 0; index < raw.length; index += 1) bytes[index] = raw.charCodeAt(index);
  return bytes;
}

export function supportsWebPush(): boolean {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function subscribeToPush(vapidPublicKey: string, label: string, csrfToken: string | null): Promise<void> {
  if (!supportsWebPush()) throw new Error("Este navegador no permite avisos push.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("El navegador no autorizó los avisos.");

  const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  const current = await registration.pushManager.getSubscription();
  const subscription = current ?? await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToBytes(vapidPublicKey),
  });

  await apiRequest("/api/v1/push-subscriptions", {
    method: "POST",
    csrfToken,
    body: { label, subscription: subscription.toJSON() },
  });
}
